import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { SupportTicket } from './../../models/support-ticket';
import { User } from './../../models/program/user';
import { NewAndExistingUsers } from '../../models/program/new-and-existing-users';
import { UserWelcomeMessage } from '../../models/program/user-welcome-message';
// import { GroupUsers } from './../../models/program/group-users';
import { ApiService } from '../../root-services/api.service';

@Injectable()
export class UserService {
  private programsUrl: string = '/programs';

  constructor(private api: ApiService) { }

  /**
   * User Methods
   */

  public getUser(userId: number): Observable<User> {
    return this.api.get(`/users/${userId}`)
                   .map((response: Response) => response.json() as User)
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

   public deleteGroupUsers(programId: number, groupId: number, ids: number[]): Observable<Response> {
     const body = { user_ids: ids };
     return this.api.post(`${this.programsUrl}/${programId}/groups/${groupId}/actions/remove_users`, body)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public deleteSessionUsers(programId: number, sessionId: number, ids: number[]): Observable<Response> {
     const body = { user_ids: ids };
     return this.api.post(`${this.programsUrl}/${programId}/sessions/${sessionId}/actions/remove_users`, body)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public addGroupUsers(programId: number, groupId: number, users: NewAndExistingUsers, welcome?: UserWelcomeMessage): Observable<Response> {
     let request_body = {users};
     if(welcome) {
       request_body['welcome'] = welcome;
     }
     return this.api.post(`${this.programsUrl}/${programId}/groups/${groupId}/actions/add_group_users`, request_body)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public addSessionUsers(programId: number, oldSessionId: number, newSessionId: number, users: NewAndExistingUsers): Observable<Response> {
     let request_body = {
      users: users,
      target_session: newSessionId
    }

     return this.api.post(`${this.programsUrl}/${programId}/sessions/${oldSessionId}/actions/add_session_users`, request_body)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public saveUserSettings(userId: number, body: any): Observable<Response> {
     return this.api.put(`/users/${userId}`, body)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

  public getSupportTickets(): Observable<SupportTicket[]> {
    return this.api.get(`/support-tickets`)
                   .map((response: Response) => response.json() as SupportTicket[])
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

   public impersonateUser(userId: number, reason: string): Observable<string> {
     return this.api.post(`/users/${userId}/actions/impersonate`, { reason })
                    .map((response: Response) => response.json().url)
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public deleteUser(userId: number): Observable<Response> {
     return this.api.delete(`/users/${userId}`)
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   public connectSso(userId: number, saml_provider_id: number): Observable<Response> {
     return this.api.post(`/users/${userId}/actions/connect_sso`, {saml_provider_id})
                    .map((response: Response) => {})
                    .publishReplay(1).refCount()
                    .catch(this.handleError);
   }

   /**
    * Private
    */

    private handleError(error: any): Promise<any> {
      console.error('An error occurred:', error);
      return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/user.service.ts